import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";

import { WizardTabbed } from "components/shared/StorefrontWizard/WizardTabbed/WizardTabbed";
import { WizardHero } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { UitkSpacingProps, UitkSpacing } from "uitk-react-spacing";

export const StorefrontWizardRegionBEXViewV2 = (props: {
  heroImageSrc: string;
  heroImageColor: string;
  context: any;
  trackOnChangeTab: (tab: string) => void;
  wizardFormChildren: React.ReactElement[];
  wizardLOBs: ExtendedFTNode[];
  wizardState: ClientWizardStateStore;
  cdgTreatment?: boolean;
  aboveOtherFormChildren: React.ReactElement[];
  belowOtherFormChildren: React.ReactElement[];
  heading?: string;
  subHeading?: string;
}) => {
  const {
    wizardLOBs,
    context,
    wizardFormChildren,
    trackOnChangeTab,
    belowOtherFormChildren,
    aboveOtherFormChildren,
    cdgTreatment,
  } = props;
  const className = "StorefrontWizardRegionBEX";

  const regionSpacing: UitkSpacingProps = { padding: { blockend: "unset" }, margin: { blockend: "unset" } };
  const wizardHero = <WizardHero heroImageFigureClassNames="bexHeroImageFigure bexHeroImageFigureV2" {...props} />;
  const wizardRender = cdgTreatment ? (
    wizardHero
  ) : (
    <Viewport>
      <ViewSmall>
        <WizardTabbed
          wizardLOBs={wizardLOBs}
          context={context}
          wizardFormChildren={wizardFormChildren}
          trackOnChangeTab={trackOnChangeTab}
          belowOtherFormChildren={belowOtherFormChildren}
          aboveOtherFormChildren={aboveOtherFormChildren}
        />
      </ViewSmall>
      <ViewMedium>{wizardHero}</ViewMedium>
    </Viewport>
  );

  return (
    <UitkSpacing {...regionSpacing}>
      <div className={`${className}`} data-testid="storefront-region">
        <div id="wizardMainRegionV2" data-testid="main-region">
          {wizardRender}
        </div>
      </div>
    </UitkSpacing>
  );
};
